import image1 from '../../images/Image/Rectangle 26.png';
import image2 from '../../images/Image/Rectangle 27.png';
import image3 from '../../images/Image/Rectangle 28.png';


const searchData = [
    {
        name: 'Light bright airy stylish apt & safe peaceful stay',
        rating: 4.9,
        ratedBy: 20,
        image: image1,
        price: 34,


    },
    {
        name: 'Apartment in Lost Panorama',
        rating: 4.8,
        ratedBy: 10,
        image: image2,
        price: 52,
    },
    {
        name: 'Light bright airy stylish apt & safe peaceful stay',
        rating: 4.9,
        ratedBy: 25,
        image: image3,
        price: 44,
    }
];

export default searchData;